export default __webpack_public_path__ + "static/media/expl-gradcam_11_EN.d94fe7b7.png";